import { providers } from './index';

export default {
  install(Vue: any) {
    Vue.prototype.$di = providers;
  },
};
